function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function parse3dlookJsonRecord(value: unknown): Record<string, unknown> | null {
  if (isRecord(value)) {
    return value;
  }

  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  try {
    const parsed = JSON.parse(value) as unknown;
    return isRecord(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function extract3dlookDataRecord(record: Record<string, unknown>): Record<string, unknown> | null {
  const sources = [
    record.data_3dlook,
    record.data3dlook,
    record.data_3dlook_json,
    record.data3dlookJson,
  ];

  for (const source of sources) {
    const parsed = parse3dlookJsonRecord(source);
    if (parsed) {
      return parsed;
    }
  }

  return null;
}

export function collect3dlookLookupRecords(user: unknown): Record<string, unknown>[] {
  if (!isRecord(user)) {
    return [];
  }

  const candidates: unknown[] = [
    user.measurements,
    user.measurement_profile,
    user.measurementProfile,
    user.fit_profile,
    user.fitProfile,
    user.data_3dlook,
    user.data3dlook,
    user.data_3dlook_json,
    user.data3dlookJson,
    isRecord(user.account) ? user.account.data_3dlook : undefined,
    isRecord(user.account) ? user.account.data3dlook : undefined,
    isRecord(user.account) ? user.account.data_3dlook_json : undefined,
    isRecord(user.account) ? user.account.data3dlookJson : undefined,
    isRecord(user.profile) ? user.profile.data_3dlook : undefined,
    isRecord(user.profile) ? user.profile.data3dlook : undefined,
    isRecord(user.profile) ? user.profile.data_3dlook_json : undefined,
    isRecord(user.profile) ? user.profile.data3dlookJson : undefined,
    extract3dlookDataRecord(user),
    isRecord(user.account) ? extract3dlookDataRecord(user.account) : null,
    isRecord(user.profile) ? extract3dlookDataRecord(user.profile) : null,
  ];

  const seen = new Set<Record<string, unknown>>();
  const records: Record<string, unknown>[] = [];

  for (const candidate of candidates) {
    const parsed = parse3dlookJsonRecord(candidate);
    if (!parsed || seen.has(parsed)) {
      continue;
    }

    seen.add(parsed);
    records.push(parsed);
  }

  return records;
}
